import React from "react";
import AsyncAutoCompleteContained from "../../AsyncAutoCompleteContained";
import { AutoCompleteProps } from "../../../Types/AutoComplete/AutoCompleteProps"
import { useTranslation } from "react-i18next";

const LanguageAutoComplete: React.FC<AutoCompleteProps> = ({
    onChange,
    valueId,
    label,
    load = true,
    disabled = false,
    infoText, error, helperText
}) => {
    const { t } = useTranslation();
    return (
        <AsyncAutoCompleteContained
            label={label ?? t("common.language")}
            url="/autocompleteApi/Language"
            valueId={valueId}
            load={load}
            onChange={onChange}
            disabled={disabled}
            infoText={infoText}
            error={error}
            helperText={helperText}
            
        />
    );
};

export default LanguageAutoComplete;
